import { defaultOpenHours } from 'app/lib/officeHours'
import type { AvailabilityType, OpenHours } from 'app/types/entities'

export const OPEN_HOURS_DAYS = [`sunday`, `monday`, `tuesday`, `wednesday`, `thursday`, `friday`, `saturday`] as const

/**
 * Strip GraphQL `__typename` keys from openHours so the value can seed the
 * editor and be serialized into the `timeSlots` form field cleanly. A null day
 * is dropped and null `hours` become `[]`, so the value matches the form schema.
 */
export function stripOpenHours(hours: OpenHours): OpenHours {
  const result: OpenHours = {}
  for (const day of OPEN_HOURS_DAYS) {
    const value = hours[day]
    if (!value) continue
    result[day] = {
      open: value.open,
      hours: (value.hours ?? []).map((range) => ({ from: range.from, to: range.to })),
    }
  }
  return result
}

/**
 * Resolve the initial weekly hours shown in the availability modal.
 *
 * - Editing an existing availability: its saved slots, normalized.
 * - Creating a new availability: the location's business hours from location
 *   settings (with GraphQL `__typename` keys stripped).
 * - Creating when the location has no business hours configured: the standard
 *   weekday default (Mon–Fri open 10:00–18:00, weekends closed).
 */
export function resolveInitialWeeklyHours(
  editingAvailability: AvailabilityType | undefined,
  locationOpenHours: OpenHours | undefined,
): OpenHours {
  if (editingAvailability?.timeSlots) return stripOpenHours(editingAvailability.timeSlots)
  if (locationOpenHours) return stripOpenHours(locationOpenHours)
  return defaultOpenHours
}
